import { ALLOWED_FILE_TYPES } from '../types';
import React from 'react';
import { DescriptionOutlined } from '@mui/icons-material';

interface UploadedFileBadgeProps {
  file: File;
}
const UploadedFileBadge = ({ file }: UploadedFileBadgeProps) => (
  <div className="uploaded-file-badge d-flex align-items-center justify-content-between p-2 gap-1">
    <div className="d-flex flex-column">
      <DescriptionOutlined />
    </div>
    <div className="d-flex flex-column info-column">
      <div className="d-flex flex-row name-row">
        {getReadableFileName(file.name)}
      </div>
      <div className="d-flex flex-row size-and-type-row">
        <span>
          <i>{getReadableFileSize(file.size)}</i>
        </span>
        <span>|</span>
        <span>
          <i>{getReadableFileType(file.type)}</i>
        </span>
      </div>
    </div>
  </div>
);

const getReadableFileName = (fileName: string) => {
  const finalPeriodIndex = fileName.lastIndexOf('.');
  return finalPeriodIndex === -1
    ? fileName
    : fileName.substring(0, finalPeriodIndex);
};

const withoutPeriods = ALLOWED_FILE_TYPES.map((val) => val.slice(1));

const getReadableFileType = (fileType: string) =>
  withoutPeriods.find((val) => fileType.includes(val)) ?? fileType;

const getReadableFileSize = (fileSize: number) => {
  const sizeInKB = fileSize / 1024;
  const sizeInMB = fileSize / (1024 * 1024);
  return sizeInMB > 1
    ? `${sizeInMB.toFixed(2)} MB`
    : sizeInKB > 1
      ? `${sizeInKB.toFixed(2)} KB`
      : `${fileSize} bytes`;
};

export default UploadedFileBadge;
